var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-agent-card-wrap" }, [
    _c("div", { staticClass: "go-widget-top-list" }, [
      _vm.isMyAgent
        ? _c("div", { staticClass: "go-list-item" }, [
            _c("div", { staticClass: "go-widget go-widget-top" }, [
              _c("div", { staticClass: "go-widget-header" }, [
                _c("div", { staticClass: "go-widget-title" }, [
                  _vm._v(
                    "🗓️ " +
                      _vm._s(_vm.isPaid ? "Daily Goover" : "Weekly Goover")
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-widget-body" }, [
                _c(
                  "div",
                  {
                    staticClass: "go-list-item",
                    attrs: {
                      "data-template": "agent-recap",
                      "data-size": "2x1",
                    },
                  },
                  [
                    _c("div", { staticClass: "go-card-main" }, [
                      _vm.recapData.length && _vm.recapData[0].parentDocDetail
                        ? _c("div", { staticClass: "go-card-body" }, [
                            _c(
                              "a",
                              {
                                staticClass: "go-card-title",
                                on: {
                                  click: function ($event) {
                                    return _vm.showRecap(
                                      _vm.recapData[0].parentDocDetail
                                        .recap_data.recap_id
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.recapData[0].parentDocDetail
                                        .recap_data.recap_title
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "go-card-desc" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.recapData[0].parentDocDetail.recap_data
                                    .recap_introduction
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("ul", { staticClass: "go-card-list" }, [
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.goToSection(
                                          _vm.recapData[0].parentDocDetail
                                            .recap_data.recap_id,
                                          0
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.recapData[0].parentDocDetail
                                          .recap_data.sections[0].topic
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.recapData[0].parentDocDetail.recap_data
                                .sections.length > 1
                                ? _c("li", [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.goToSection(
                                              _vm.recapData[0].parentDocDetail
                                                .recap_data.recap_id,
                                              0
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.recapData[0].parentDocDetail
                                              .recap_data.sections[1].topic
                                          )
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.recapData[0].parentDocDetail.recap_data
                                .sections.length > 2
                                ? _c("li", [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.goToSection(
                                              _vm.recapData[0].parentDocDetail
                                                .recap_data.recap_id,
                                              0
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.recapData[0].parentDocDetail
                                              .recap_data.sections[2].topic
                                          )
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-card-footer" }, [
                        _c("div", { staticClass: "go-info-inline" }, [
                          _c(
                            "span",
                            { staticClass: "go-info-item go-datetime" },
                            [
                              _c("em", { staticClass: "go-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.convertDateToYYYYMMDD(
                                      new Date(
                                        _vm.recapData[0] &&
                                        _vm.recapData[0].published_at
                                          ? _vm.recapData[0].published_at
                                          : ""
                                      ).toLocaleString()
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.currentPodcast
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn go-btn-default go-btn-play go-btn-sm",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.togglePodcastDropdown(
                                      _vm.recapData[0].parentDocDetail
                                        .recap_data.recap_id
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "go-icon-20 go-icon-headphones",
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "go-text" }, [
                                  _vm._v(_vm._s(_vm.formatTime(_vm.totalTime))),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pod-cast-drop" },
              [
                _vm.openPodcast
                  ? _c("podcast-loading", {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.closePodcastLoading,
                          expression: "closePodcastLoading",
                        },
                      ],
                      staticClass: "podcast-modal",
                      attrs: {
                        podcast: _vm.currentPodcast,
                        recapTitle: _vm.recapTitle,
                        isHideSetting: true,
                      },
                      on: { "go-back": _vm.handleGoBack },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "go-list-item",
          style: _vm.isMyAgent ? {} : { "grid-column": "span 4" },
        },
        [
          _c("div", { staticClass: "go-widget go-widget-top" }, [
            _c("div", { staticClass: "go-widget-header" }, [
              _c("div", { staticClass: "go-widget-title" }, [
                _vm._v("Featured Agents"),
              ]),
              _vm._v(" "),
              _vm.briefingPages.length > 1
                ? _c("div", { staticClass: "go-carousel-control top-left" }, [
                    _c("div", {
                      staticClass: "go-carousel-indicators num",
                      attrs: { id: "pag-num" },
                    }),
                    _vm._v(" "),
                    _vm._m(0),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-widget-body" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "swiper",
                      rawName: "v-swiper",
                      value: _vm.swiperOptions,
                      expression: "swiperOptions",
                    },
                  ],
                  ref: "mainSwiper",
                  staticClass: "swiper goSwiperCard",
                },
                [
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper" },
                    _vm._l(_vm.briefingPages, function (item, index) {
                      return _c("briefing-card", {
                        key: index,
                        staticClass: "swiper-slide",
                        attrs: { "form-model": item },
                        on: {
                          "select-user-social": _vm.onSelectUserSocial,
                          select: function ($event) {
                            return _vm.select(item)
                          },
                          "toggle-subscribe": function ($event) {
                            return _vm.toggleSubscribed(item, index)
                          },
                        },
                      })
                    }),
                    1
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-btn-group" }, [
      _c(
        "button",
        { staticClass: "go-carousel-nav-prev", attrs: { type: "button" } },
        [_c("i", { staticClass: "go-icon-20 go-icon-chevron-left" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "go-carousel-nav-next", attrs: { type: "button" } },
        [_c("i", { staticClass: "go-icon-20 go-icon-chevron-right" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }